"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetProductBoxConfiguration = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _api = require("../api");
var _useSWRFetch = require("./internal/useSWRFetch");
// istanbul ignore file @preserve -- api

const useGetProductBoxConfiguration = () => {
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  return (0, _useSWRFetch.useSWRFetch)({
    fallback: {
      isMrpStatementEnabled: false,
      isRatingsAndReviewsEnabled: false
    },
    fetcher: async () => (0, _api.getProductBoxConfiguration)({
      staticApiUrl,
      tenant
    }),
    key: [staticApiUrl, tenant]
  });
};
exports.useGetProductBoxConfiguration = useGetProductBoxConfiguration;
